import { useState } from 'react';
import Flex from '@deprecated-ui/common/Flex';
import Text from '@deprecated-ui/common/Text';
import Iconmoon from '@deprecated-ui/common/Iconmoon';
import color from '@deprecated-ui/_style/color';
import Image from 'global/Image';
import If from 'global/ErrorHandlers/If';
import { ORDER_TYPE } from 'constants/trading';
import { formatNumber } from 'utils/number';
import { getColorBasedOnNumber } from 'utils/general';
import tradingDataStore from 'lib/stores/tradingData';
import SearchCompany from './SearchCompany';
import CompanyLabel from './CompanyLabel';
import BidOfferBox from './BidOfferBox';
import { FormHeader } from '../styled';
import { SymbolAvatar, PriceWrapper } from './styled';

interface TransactionHeaderProps {
  orderType: string;
  isSearchActive: boolean;
  showTitle?: boolean;
  onUpdateSymbol: (symbol) => void;
  setIsSearchActive: () => void;
}

function TransactionHeader({
  orderType,
  onUpdateSymbol,
  isSearchActive,
  showTitle = true,
  setIsSearchActive,
}: TransactionHeaderProps) {
  const { data } = tradingDataStore((s) => s.company);
  const [showSearch, setShowSearch] = useState<boolean>(false);

  if (!data) return null;

  const { icon_url, change, name, percentage, price, symbol, orderbook } = data;

  const isBuy = orderType === ORDER_TYPE.VIRTUAL_BUY;
  const isAmendBuy = orderType === ORDER_TYPE.VIRTUAL_AMEND_BUY;

  const modalTitles = {
    [ORDER_TYPE.VIRTUAL_BUY]: 'Buy',
    [ORDER_TYPE.VIRTUAL_SELL]: 'Sell',
    [ORDER_TYPE.VIRTUAL_AMEND_BUY]: 'Amend Buy',
    [ORDER_TYPE.VIRTUAL_AMEND_SELL]: 'Amend Sell',
  };

  return (
    <>
      <If condition={showTitle}>
        <Text
          family="bold"
          color={isBuy || isAmendBuy ? color.primary : color.sunsetOrange}
          size="24px"
          align="center"
        >
          {modalTitles[orderType]}
        </Text>
      </If>
      {/* @ts-expect-error */}
      <FormHeader mt="30px">
        <Flex
          justify="space-between"
          width="100%"
          style={{ display: isSearchActive ? 'none' : 'flex' }}
        >
          <Flex align="flex-start">
            {!icon_url ? (
              <SymbolAvatar>
                <Text color="white" family="bold" size="16px">
                  {symbol[0]}
                </Text>
              </SymbolAvatar>
            ) : (
              <Image
                src={icon_url}
                style={{ width: '40px', height: '40px', background: 'white' }}
              />
            )}
            {/* @ts-expect-error */}
            <Flex direction="column" pl="15px">
              <Flex align="center">
                <Text family="bold" size="16px">
                  {symbol}
                </Text>
                <CompanyLabel data={data} />
              </Flex>
              {/* @ts-expect-error */}
              <Flex mt="3px">
                {/* @ts-expect-error */}
                <Text size="14px" color={color.midgray} mr="5px">
                  {name}
                </Text>
                {(isBuy || isAmendBuy) && (
                  <Iconmoon
                    className="icon-tradesmall_pencil2"
                    size="14px"
                    hoverColor={color.highgray}
                    onClick={() => {
                      setIsSearchActive();
                      setShowSearch(!showSearch);
                    }}
                  />
                )}
              </Flex>
            </Flex>
          </Flex>
          <Flex align="center">
            <PriceWrapper>
              <Text family="bold">{formatNumber(price, false)}</Text>
              &nbsp;
              <Text color={getColorBasedOnNumber(change)}>
                {change && change.slice(1)}
              </Text>
              <Text
                color={() => {
                  if (change === 0) return color.nightRider;
                  if (change > 0) return color.primary;
                  return color.sunsetOrange;
                }}
              >
                ({percentage > 0 && '+'}
                {formatNumber(percentage, false, '0.00%')})
              </Text>
            </PriceWrapper>
            <BidOfferBox orderbook={orderbook} />
          </Flex>
        </Flex>

        {isSearchActive && (
          <Flex width="100%">
            <SearchCompany
              isInTradingModal
              updateSymbol={(newSymbol) => onUpdateSymbol(newSymbol)}
            />
          </Flex>
        )}
      </FormHeader>
    </>
  );
}

export default TransactionHeader;
